import React, { Component } from 'react'

import CloseIcon from  '../partials/icons/close'
import Store from '../store/ProductionTableStore'
import { observer } from 'mobx-react'

@observer
class Popup extends Component {
    render() {
        const { show, type, order } = this.props
        let layout = null
        let orderContent = null
        let classes = ''

        if (show) {
            classes = 'popup--show'
        }

        if (!type || type === 'default') {
            layout = <div className="card-person">
                <div className="card-person__header">
                    <h2 className="card-person__header__title">Kontaktuppgifter</h2>
                </div>
                <div className="card-person__main">
                    <div className="card-person__main__item">
                        <label className="card-person__main__item__label">Namn</label>
                        <input className="card-person__main__item__input" readOnly value={ Store.popup.data.name ? Store.popup.data.name : 'Ej angivet' } />
                    </div>
                    <div className="card-person__main__item">
                        <label className="card-person__main__item__label">Telefon</label>
                        <input className="card-person__main__item__input" readOnly value={ Store.popup.data.phone ? Store.popup.data.phone : 'Ej angivet' } />
                    </div>
                    <div className="card-person__main__item">
                        <label className="card-person__main__item__label">Mobiltelefon</label>
                        <input className="card-person__main__item__input" readOnly value={ Store.popup.data.cellphone ? Store.popup.data.cellphone : 'Ej angivet' } />
                    </div>
                    <div className="card-person__main__item">
                        <label className="card-person__main__item__label">E-post</label>
                        <input className="card-person__main__item__input" readOnly value={ Store.popup.data.email ? Store.popup.data.email : 'Ej angivet' } />
                    </div>
                    <div className="card-person__main__item">
                        <label className="card-person__main__item__label">Roll</label>
                        <input className="card-person__main__item__input" readOnly value={ Store.popup.data.role ? Store.popup.data.role : 'Ej angivet' } />
                    </div>
                    <div className="card-person__main__item card-person__main__item--lg">
                        <label className="card-person__main__item__label">Anteckningar</label>
                        <textarea className="card-person__main__item__textarea" readOnly value={ Store.popup.data.note ? Store.popup.data.note : 'Inga anteckningar sparade.' }></textarea>
                    </div>
                </div>
            </div>
        } else if (type === 'warning') {
            classes += ' popup--small'

            if (order.order_paused) {
                orderContent = <div className="warning__inner">
                    <h4 className="warning__title">Ordern är pausad. Vill du påbörja ordern igen?</h4>

                    <div className="warning__actions">
                        <button className="warning__actions__btn pt-btn pt-btn--cta" onClick={ Store.HANDLE_UNDO_TASK_ASYNC.bind(this, 'update') }>Ja, fortsätt</button>
                    </div>
                </div>
            } else {
                if (!Store.popupOrder.showComment) {
                    orderContent = <div className="warning__inner">
                        <h4 className="warning__title">
                            { Store.taskChanged.taskPostion > -1 ? `Vill du ångra ett moment som är klarmarkerat?` : `Vill du ångra alla moment som är klarmarkerade?` }
                        </h4>
    
                        <div className="warning__actions">
                            <button className="warning__actions__btn pt-btn pt-btn--danger" onClick={ Store.HANDLE_UNDO_TASK_ASYNC.bind(this, 'pause') }>Pausa ordern</button>
                            <button className="warning__actions__btn pt-btn pt-btn--cta" onClick={ Store.HANDLE_UNDO_TASK_ASYNC.bind(this, 'update') }>Ja, fortsätt</button>
                        </div>
                    </div>
                } else {
                    orderContent = <div className="warning__inner">
                        <h4 className="warning__title">Du är påväg att pausa denna order!</h4>

                        <div className="warning__comment">
                            <textarea
                                className="warning__comment__txtarea"
                                placeholder="Ange anledning till pausad order här..."
                                onChange={ Store.HANDLE_ADD_ORDER_COMMENT }
                                value={ Store.currentComment }
                            >
                            </textarea>
                            <button className="pt-btn pt-btn--danger" onClick={ Store.HANDLE_UNDO_TASK_ASYNC.bind(this, 'pauseReq') }>Pausa</button>
                        </div>                    
                    </div>
                }
            }

            layout = <div className="warning">{ orderContent }</div>
        }

        return <div className={ `popup ${ classes }` }>
            <div className="popup__inner">
                <header className="popup__inner__header">
                    <span className="popup__inner__header__close" onClick={ Store.HANDLE_CLOSE_POP_UP }>
                        Stäng
                        <CloseIcon />
                    </span>
                </header>

                <div className="popup__inner__main">
                    { layout }
                </div>
            </div>
        </div>
    }
}

export default Popup
